import React, { useState } from 'react'
import { Box, Textarea, Button, Group, Flex, Text, Rating, Stack, Grid, Select } from '@mantine/core'
import { submitFeedbackUserProgram } from '../../../../services/userPrograms'
import { notificationSuccess, notificationError } from '../../../ui/Notification'

const defaultVal = {
  tutorMasteryRating: 5,
  tutorClarityRating: 5,
  tutorTimeRating: 5,
  tutorInteractionRating: 5,
  tutorCriticism: '',
  orgTechnicalRating: 5,
  orgMaterialRating: 5,
  orgMethodRating: 5,
  orgCriticism: '',
  mostLiked: '',
  improvement: '',
  infoSource: ''
}

const FormFeedbackProgram = ({ userCompletionId, onCloseModal, reloadDetail, onSubmitSuccess }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)
  
  const handleRating = (name, e) => {
    setFormData({ ...formData, [name]: e })
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSelect = (val) => {
    setFormData({ ...formData, infoSource: val })
  }

  const submitFeedback = async (formFeedback) => {
    if (!formFeedback.mostLiked || !formFeedback.improvement || !formFeedback.infoSource) {
      notificationError('Form tidak lengkap', 'Pastikan Informasi Pelatihan, Hal yang Paling Disukai, dan Saran/Perbaikan sudah diisi.')
      return
    }

    setLoadingForm(true)
    try {
      const response = await submitFeedbackUserProgram(userCompletionId, formFeedback)
      if (response) {
        onCloseModal()
        reloadDetail()
        if (onSubmitSuccess) {
          onSubmitSuccess()
        }
        notificationSuccess('Submit Feedback Berhasil', 'Terima kasih anda telah mengisi feedback dari training ini')
      }
    } catch (error) {
      console.log(error)
      notificationError('Gagal Submit Feedback', 'Silahkan cek kembali form anda')
    } finally {
      setLoadingForm(false)
    }
  }

  return (
    <Box>
      <Box mb='xl'>
        <Text fz={18} fw='600' mb='md'>Penilaian Pengajar/Tutor (Materi)</Text>
        <Grid>
          <Grid.Col span={6}><Text size="sm">Penguasaan Materi</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.tutorMasteryRating} onChange={(e) =>handleRating('tutorMasteryRating', e)} /></Grid.Col>

          <Grid.Col span={6}><Text size="sm">Kejelasan Penyampaian</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.tutorClarityRating} onChange={(e) =>handleRating('tutorClarityRating', e)} /></Grid.Col>

          <Grid.Col span={6}><Text size="sm">Disiplin Waktu</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.tutorTimeRating} onChange={(e) =>handleRating('tutorTimeRating', e)} /></Grid.Col>

          <Grid.Col span={6}><Text size="sm">Interaksi & Tanggap</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.tutorInteractionRating} onChange={(e) =>handleRating('tutorInteractionRating', e)} /></Grid.Col>
        </Grid>
      </Box>

      <Box mb='xl'>
        <Text fz={18} fw='600' mb='md'>Penilaian Penyelenggara (Fasilitas)</Text>
        <Grid>
          <Grid.Col span={6}><Text size="sm">Kualitas Teknis LMS</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.orgTechnicalRating} onChange={(e) =>handleRating('orgTechnicalRating', e)} /></Grid.Col>

          <Grid.Col span={6}><Text size="sm">Kualitas Materi/Modul</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.orgMaterialRating} onChange={(e) =>handleRating('orgMaterialRating', e)} /></Grid.Col>

          <Grid.Col span={6}><Text size="sm">Kesesuaian Metode</Text></Grid.Col>
          <Grid.Col span={6}><Rating value={formData.orgMethodRating} onChange={(e) =>handleRating('orgMethodRating', e)} /></Grid.Col>
        </Grid>
      </Box>

      <Stack spacing="md">
        <Select
          label="Informasi Pelatihan dari"
          placeholder="Pilih sumber informasi"
          data={['Medsos', 'Teman', 'Iklan', 'Lainnya']}
          value={formData.infoSource}
          onChange={handleSelect}
          withAsterisk
        />
        <Textarea
          name='mostLiked'
          value={formData.mostLiked}
          label='Hal yang Paling Disukai'
          placeholder='Ceritakan hal yang paling disukai dari pelatihan ini'
          onChange={handleChange}
          withAsterisk
        />
        <Textarea
          name='improvement'
          value={formData.improvement}
          label='Saran/Perbaikan'
          placeholder='Saran dan perbaikan untuk pelatihan ini'
          onChange={handleChange}
          withAsterisk
        />
        <Textarea
          name='tutorCriticism'
          value={formData.tutorCriticism}
          label='Kritik & Saran untuk Tutor (Opsional)'
          placeholder='Masukan atau saran spesifik untuk Tutor/Pengajar'
          onChange={handleChange}
        />
        <Textarea
          name='orgCriticism'
          value={formData.orgCriticism}
          label='Kritik & Saran Penyelenggara (Opsional)'
          placeholder='Masukan atau saran untuk penyelenggaraan fasilitas/kelas'
          onChange={handleChange}
        />
      </Stack>

      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button variant="outline" color='indigo.9' onClick={onCloseModal}>Tutup</Button>
            <Button loading={loadingForm} variant="filled" color='indigo.9' onClick={() => submitFeedback(formData)}>Kirim Feedback & Download</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormFeedbackProgram